export function createTabs() {
  const tabs = document.querySelectorAll('.js-tab');

  if (tabs) {
    tabs.forEach(elem => {
      const tab = new Tab(elem);
      tab.init();
    });
  }
}

class Tab {
  constructor(elem) {
    this._elem = elem;
    this._btnContainer = this._elem.querySelector('.tab__buttons');
    this._btns = this._elem.querySelectorAll('.tab__button');
    this._contentContainer = this._elem.querySelector('.tab__inner');
    this._contents = this._contentContainer.querySelectorAll('.tab__content');
    this._activeId = null;

    this._windowHashChangeHandler = this._windowHashChangeHandler.bind(this);
    this._elemClickHandler = this._elemClickHandler.bind(this);
  }

  init() {
    if (!this._isInit()) {
      this._elem.classList.add('is-initialized');
    }
    window.addEventListener('hashchange', this._windowHashChangeHandler);
    this._btnContainer.addEventListener('click', this._elemClickHandler);

    this._checkHash();
  }

  _windowHashChangeHandler() {
    this._checkHash();
  }

  _elemClickHandler(evt) {
    const id = evt.target.dataset.id;

    if (id) {
      evt.preventDefault();

      this._activeBtn = evt.target;
      this._activeId = this._activeBtn.dataset.id;

      this._btns.forEach(btn => {
        btn.classList.remove('active');
      });
      this._activeBtn.classList.add('active');

      this._contents.forEach(content => {
        content.classList.remove('active');
      });

      this._activeContainer = this._contentContainer.querySelector(`[data-content=${this._activeId}]`);
      this._activeContainer.classList.add('active');

      this._setHash();
    }
  }

  _setHash() {
    window.location.hash = this._activeId;
  }

  _checkHash() {
    const btnWithWindowHash = Array.from(this._btns).find(btn => `#${btn.dataset.id}` === window.location.hash);
    if (btnWithWindowHash) {
      btnWithWindowHash.click();
    }
  }

  _isInit() {
    return this._elem.classList.contains('is-initialized');
  }
}
